import { ConsultationArtefact } from '../types/consultation'
import { formatDate } from '../utils/locale'
import './ConsultationArtefactList.css'

interface ConsultationArtefactListProps {
  consultationId: string
  artefacts: ConsultationArtefact[]
  onArtefactClick?: (artefact: ConsultationArtefact) => void
}

export function ConsultationArtefactList({
  artefacts,
  onArtefactClick,
}: ConsultationArtefactListProps) {
  const getArtefactIcon = (type: ConsultationArtefact['type']) => {
    switch (type) {
      case 'referral-letter':
        return '📄'
      case 'prescription':
        return '💊'
      case 'lab-order':
        return '🧪'
      case 'imaging-order':
        return '📷'
      case 'certificate':
        return '📜'
      default:
        return '📋'
    }
  }

  const getStatusBadge = (status: ConsultationArtefact['status']) => {
    const statusClasses = {
      draft: 'artefact-status-draft',
      issued: 'artefact-status-issued',
      sent: 'artefact-status-sent',
      completed: 'artefact-status-completed',
    }
    return <span className={`artefact-status ${statusClasses[status]}`}>{status}</span>
  }

  if (!artefacts || artefacts.length === 0) {
    return (
      <div className="artefact-list-empty">
        <p>No artefacts created for this consultation yet.</p>
        <p className="hint">Click "Add Artefact" to create a referral letter, prescription, or other document.</p>
      </div>
    )
  }

  return (
    <div className="artefact-list">
      {artefacts.map((artefact) => (
        <div
          key={artefact.id}
          className="artefact-item"
          onClick={() => onArtefactClick?.(artefact)}
        >
          <div className="artefact-icon">{getArtefactIcon(artefact.type)}</div>
          <div className="artefact-content">
            <div className="artefact-header">
              <h4>{artefact.title}</h4>
              {getStatusBadge(artefact.status)}
            </div>
            <div className="artefact-meta">
              <span className="artefact-type">{artefact.type.replace('-', ' ')}</span>
              {artefact.referenceNumber && (
                <span className="artefact-reference">Ref: {artefact.referenceNumber}</span>
              )}
              <span className="artefact-date">{formatDate(artefact.createdAt)}</span>
            </div>
            {artefact.description && (
              <p className="artefact-description">{artefact.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

































